import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";


@Component({
  selector: 'app-appointment-reasonreamrks-dialog',
  templateUrl: './appointment-reasonreamrks-dialog.component.html',
  styleUrls: ['./appointment-reasonreamrks-dialog.component.scss']
})
export class AppointmentReasonreamrksDialogComponent implements OnInit,OnDestroy {
  reason: any;
  remarks:any;
  constructor(public dialogRef: MatDialogRef<AppointmentReasonreamrksDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

    reasonValue:any;
    remarksValue: any;

  ngOnInit() {
    this.reasonValue=this.data.reason;
    this.remarksValue=this.data.remarks;
  }
  /**
   *on close method
   *
   * @memberof AppointmentReasonreamrksDialogComponent
   */
  onNoClick() {
   
   this.dialogRef.close();
  }
   
  /**
   *Destroy method
   *
   * @memberof AppointmentReasonreamrksDialogComponent
   */
  ngOnDestroy() {
    
  }
}
